import { useState } from "react";
import { GetRequest } from "../../utils/api";
import { Card, Col, Popover, Row } from "antd";
import moment from "moment";
import styles from "./AppNotification.module.scss";
import { commonApis } from "./../../utils/ApiURLs";
import React from 'react';
import CustomIcon from "../icons/CustomIcon";
import CustomLoader from "../loader";



const AppNotification: React.FC = () => {


  const [notifs, setNotifs] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);


  const fetchData = async (page = 0, size = 5) => {

    try {

      GetRequest(commonApis.notficationsApi + `?size=${size}&page=${page}`).then((response: any) => {

        let allNotifs = [...notifs, ...response.records];
        setNotifs(allNotifs);
        setPage(page + 1);

      });

    } catch (error) {
      console.log('Error fetching data:', error);
    }
  }

  const content = () => {

    if (notifs.length > 0) {

      return (
        <div className={styles.popoverContainer}>
          {notifs.map((notification, index: number) => {
            return <Card bodyStyle={{ borderRadius: "4px", fontSize: "14px", padding: "1rem" }} className="my-1 p-0">

              <Row>
                <Col span={2}>
                  {/* <NotificationOutlined className="mt-3" rev={undefined} /> */}
                  <CustomIcon className="mt-3"name={"announce"}></CustomIcon> 
                </Col>
                <Col span={22}>
                  <p key={index}> {notification.message}</p>
                  <p className="text-right text-primary">

                    <CustomIcon name={"calendar"}></CustomIcon> 
                    {moment(notification?.creationDtm).format('MMMM D, YYYY')}</p>
                
                </Col>
              </Row>
            </Card>

          })}
          <p className="pointer mt-3 mb-2 text-primary text-center" onClick={() => fetchData(page, 5)}> <u>Load more...</u> </p>
        </div>
      )

    } else {
      return (
        <>
          <div>
            <div className="bg-white">
            <CustomLoader tip={"Loading..."} size="lg"></CustomLoader>
            </div>
          </div>
        </>
      )
    }


  }


  return (
    <>
      {/* overlayInnerStyle={{ backgroundColor: "#f2f2f2", borderRadius: "5px" }} */}
      {/* overlayInnerStyle={styles.overlayInnerStyle} overlayClassName={styles.overlayInnerStyle} openClassName={styles.overlayInnerStyle} className={styles.overlayInnerStyle} */}
      <Popover color="#eee" arrowPointAtCenter={true} placement="bottomLeft" content={content} trigger="click">
        {/* <FontAwesomeIcon icon={faBell} className="pointer mr-3 text-primary" onClick={() => fetchData()} style={{ fontSize: "15px" }} /> */}
        <CustomIcon name={"notifications"} className="pointer mr-2 text-primary" onClick={() => fetchData()}></CustomIcon>
      </Popover>

    </>
  )

}

export default AppNotification;